<template>
  <div class="text-center">
    <div class="spinner-border text-secondary" role="status"></div>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: {
    loading: Boolean
  }
};
</script>

<style>
</style>